import { useRef, useState } from 'react';
import {
    Container,
    Contacts,
    Contact,
    CardPhone,
    ButtonAddContact,
    Loader,
    ContactName,
    Icon
} from './styled';
import {
    FaPhone,
    FaCheck
} from "react-icons/fa6";
import { BiSolidEditAlt } from "react-icons/bi";
import { IoClose } from "react-icons/io5";
import { Avatar, Modal } from '../../../../../components';
import {
    newContact
} from '../../../../../service/serviceChat/chatService'
import { toast } from 'react-toastify';







const RenderCardPhone = ({ contact: { phone, name } }) => {

    const refInput = useRef(null);
    const [progress, setProgress] = useState(0);
    const [contactName, setContactName] = useState('');
    const [enabledEdit, setEnabledEdit] = useState(false);

    const formatPhone = (phone) => {
        if (!phone.startsWith('55')) {
            return phone;
        }
        return phone.replace(/(\d{2})(\d{2})(\d{4})(\d{4})/, '+$1 ($2) $3-$4');
    };
    const renderIcon = (n) => {
        switch (n) {
            case 0:
                return <FaPhone />
            case 1:
                return <FaPhone />
            case 2:
                return <Loader />
            case 3:
                return (
                    <Icon className='ic-s'>
                        <FaCheck />
                    </Icon>
                )
            case 4:
                return (
                    <Icon className='ic-e'>
                        <IoClose />
                    </Icon>
                )
            default:
                return <></>
        }
    };

    function handleAddContact() {
        setEnabledEdit(false)
        setProgress(1)
        setContactName(name)
    }
    function handleEnableEdit() {
        refInput.current.focus();
        setEnabledEdit(true);
    };
    async function handleCreateNewContact() {
        setProgress(2);
        const { status, message } = await newContact(contactName, phone);
        if (status === 'error') {
            toast.error(
                message,
                {
                    position: "top-center",
                    theme: "colored",
                }
            );
            setProgress(4);
            return;
        } else {
            toast.success(
                `Contato ${contactName} adicionado com sucesso !`,
                {
                    position: "top-center",
                    theme: "colored",
                }
            );
            setProgress(3);
        }
    };

    return (
        <>
            <CardPhone>
                <div>
                    {renderIcon(progress)}
                    <span>{`${formatPhone(phone)}`}</span>
                </div>
                {(progress === 0) &&
                    (
                        <div className='btn--add'>
                            <ButtonAddContact onClick={() => handleAddContact()}>
                                {`Adicionar`}
                            </ButtonAddContact>
                        </div>
                    )
                }
            </CardPhone>
            <Modal
                title='Salvar como:'
                isOpen={(progress === 1)}
                close={() => setProgress(0)}
            >
                <ContactName>
                    <div>
                        <input
                            ref={refInput}
                            name='contactName'
                            id='contactName'
                            type="text"
                            value={contactName}
                            onChange={(e) => setContactName(
                                e.target.value
                            )}
                            disabled={!enabledEdit}
                        />
                        <BiSolidEditAlt
                            onClick={() => handleEnableEdit()}
                            className='ed-n'
                            fontSize={20}
                        />
                    </div>
                    <span>
                        <FaCheck
                            fontSize={20}
                            onClick={() => handleCreateNewContact()}
                        />
                    </span>
                </ContactName>
            </Modal>
        </>
    )
};

export function List({ contacts }) {

    const [openModal, setOpenModal] = useState(false);

    const RenderContact = ({ contact }) => {
        const { contact_name, contact_phones } = contact;
        return (
            <Contact>
                <div>
                    <Avatar
                        width={`3rem`}
                        height={`3rem`}
                        name={contact_name}
                    />
                    <span>
                        {contact_name}
                    </span>
                </div>
                <ul>
                    {contact_phones?.map((phone, index) => {
                        const { wa_id } = phone;
                        return (
                            <RenderCardPhone
                                key={index}
                                contact={{
                                    name: contact_name,
                                    phone: wa_id
                                }}
                            />
                        )
                    })}
                </ul>
            </Contact>
        )
    };

    return (
        <Container>
            <Contacts>
                {contacts?.map((contact, index) => {
                    return (
                        <RenderContact
                            key={index}
                            contact={contact}
                        />
                    )
                })}
            </Contacts>
        </Container>
    )
}